<template>
    <div class="card is-fullheight sticky">
        <header class="card-header">
            <p class="card-header-title">
                Search result filter
            </p>
            <a href="#" @click="showHideFilter()" class="card-header-icon" aria-label="more options">
              <span class="icon">
                <i v-if="showFilter" class="fas fa-angle-up" aria-hidden="true"></i>
                <i v-if="!showFilter" class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </a>
        </header>
        <div class="card-content" v-if="showFilter">
            <aside class="sidebar-content">
                <VuePerfectScrollbar class="scroll-area" v-once :settings="settings" :style="{ 'height': filterHeight + 'px' }">
                    <date-input></date-input>
                    <year-range-slider></year-range-slider>
                    <km-range-slider></km-range-slider>
                    <transmissions></transmissions>
                    <chassis></chassis>
                    <lot-numbers></lot-numbers>
                    <grades></grades>
                    <displacement-slider></displacement-slider>
                    <price-slider></price-slider>
                    <car-grade></car-grade>
                    <color-picker></color-picker>
                    <equipment></equipment>
                </VuePerfectScrollbar>
            </aside>
        </div>
        <submit-button v-if="showFilter"></submit-button>
    </div>
</template>

<script>
    import YearSlider from './../Specification/YearRangeSlider.vue'
    import KmSlider from './../Specification/KmRangeSlider'
    import Transmissions from './../Specification/TransmissionsSpecification'
    import Chassis from './../Specification/ChassisInput'
    import LotNumbers from './../Specification/LotNumberInput'
    import Grades from './../Specification/AuctionGrades'
    import PriceSlider from './../Specification/PriceSlider'
    import DisplacementSlider from './../Specification/DisplacementRangeSlider'
    import CarGrade from './../Specification/CarGradeInput'
    import ColorPicker from './../Specification/SpecificationColorPalette'
    import Equipment from './../Specification/SpecificationEquipment'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import Submit from './../Specification/Submit.vue'
    import DateInput from './../Specification/DateInput.vue'
    export default {
        components: {
            yearRangeSlider: YearSlider,
            kmRangeSlider: KmSlider,
            transmissions: Transmissions,
            chassis: Chassis,
            lotNumbers: LotNumbers,
            grades: Grades,
            priceSlider: PriceSlider,
            displacementSlider: DisplacementSlider,
            carGrade: CarGrade,
            colorPicker: ColorPicker,
            equipment: Equipment,
            VuePerfectScrollbar: VuePerfectScrollbar,
            submitButton: Submit,
            dateInput: DateInput
        },
        data() {
            return {
                settings: {
                    maxScrollbarLength: 60
                },
                showFilter: true,
                filterHeight: document.documentElement.clientHeight - 250,
            }
        },
        methods: {
            showHideFilter() {
                this.showFilter = this.showFilter !== true
            }

        },
        mounted () {
            document.documentElement.clientWidth < 800 ? this.showFilter = false : this.showFilter = true
        }
    }
</script>

<style scoped>
    .sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 75px;
    }
    /*.scroll-area {*/
        /*height: 650px;*/
    /*}*/

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Results/SpecificationFilter.vue